<template>
  <footer class="site-footer">
    <div class="container">
      <div class="footer-inner">
        <div class="footer-brand">
          <span class="footer-logo">Pixel<span>ated</span></span>
          <p class="footer-tagline">Full-Stack Development. Pixel Perfect.</p>
        </div>
        <div class="footer-social">
          <a href="https://www.linkedin.com/in/lloyd-larbi-501885215/" target="_blank" rel="noopener noreferrer"
            class="social-link" aria-label="LinkedIn">
            <i class="fab fa-linkedin-in"></i>
          </a>
          <a href="https://github.com/Larkings" target="_blank" rel="noopener noreferrer"
            class="social-link" aria-label="GitHub">
            <i class="fab fa-github"></i>
          </a>
        </div>
      </div>

      <div class="footer-bottom">
        <p>&copy; Pixelated 2026</p>
      </div>
    </div>
  </footer>

  <button id="myBtn" @click="scrollToTop" aria-label="Terug naar boven">
    <i class="fas fa-arrow-up"></i>
  </button>
</template>

<script setup>
function scrollToTop() {
  window.scrollTo({ top: 0, behavior: 'smooth' })
}
</script>

<style scoped>
/* Fades into deep black at the very bottom — cinematic close. */
.site-footer {
  background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.7) 55%);
  padding: 4rem 0 2rem;
}

.footer-inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 1.5rem;
  margin-bottom: 2.5rem;
}

.footer-logo {
  font-family: 'JetBrains Mono', 'Courier New', monospace;
  font-size: 1.3rem;
  font-weight: 700;
  color: #fff;
}

.footer-logo span { color: var(--accent); text-shadow: 0 0 18px var(--accent-glow); }

.footer-tagline {
  font-family: 'JetBrains Mono', 'Courier New', monospace;
  font-size: 0.78rem;
  color: rgba(255, 255, 255, 0.3);
  margin: 0.35rem 0 0;
}

.footer-social { display: flex; gap: 0.75rem; }

.social-link {
  width: 40px;
  height: 40px;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  color: rgba(255, 255, 255, 0.6);
  font-size: 0.95rem;
  text-decoration: none;
  transition: background 0.2s, color 0.2s, border-color 0.2s, transform 0.15s;
}

.social-link:hover {
  background: var(--accent-tint);
  border-color: var(--accent-line);
  color: var(--accent);
  transform: translateY(-2px);
}

.footer-bottom {
  border-top: 1px solid rgba(255, 255, 255, 0.07);
  padding-top: 1.5rem;
  text-align: center;
}

.footer-bottom p { font-size: 0.82rem; color: rgba(255, 255, 255, 0.25); margin: 0; }

#myBtn {
  position: fixed;
  z-index: 99;
  bottom: 24px;
  right: 24px;
  width: 44px;
  height: 44px;
  border: none;
  border-radius: 10px;
  background: var(--accent-grad);
  color: #0a0a0a;
  font-size: 0.9rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 20px var(--accent-glow);
  transition: filter 0.2s, transform 0.15s, box-shadow 0.2s;
}

#myBtn:hover { filter: brightness(1.06); transform: translateY(-3px); box-shadow: 0 8px 28px var(--accent-glow); }

@media (max-width: 767px) {
  .site-footer { padding: 2.5rem 0 1.75rem; }
  .footer-inner { flex-direction: column; align-items: flex-start; gap: 1.25rem; margin-bottom: 2rem; }
  .footer-bottom p { text-align: left; }
}
</style>
